<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" md="4">
        <b-card class="mb-3">
          <template v-slot:header>
            <h4>Báo cáo</h4>
          </template>
            <p>
               <a class="iq-bg-green-white report-title-icons"><i class="las la-exchange-alt text-green"></i></a>
              / <a class="iq-bg-blue-white report-title-icons"><i class="las la-check-circle text-green"></i></a>: Chốt
              báo cáo
            </p>
            <p>
              <a class="iq-bg-red-white report-title-icons"><i class="las la-times-circle text-red"></i></a>: Xóa báo cáo
            </p>
        </b-card>
        <b-card>
          <b-table
            id="report-list-table"
            ref="reportListTableRef"
            :items="reportList"
            :fields="reportFields"
            :busy.sync="isBusy"
            :primary-key="'id'"
            class="table-striped"
            role="grid"
            aria-describedby="user-list-page-info"
          >
            <template v-slot:cell(report_range)="data">
              <div class="flex align-items-center">
                <a href="#" style="color: #1e3d73; font-size: 1em;" @click="loadDetailReport(data.item.id)">{{data.item.from_date | formatDateVN}} - {{data.item.to_date | formatDateVN}}</a>
              </div>
            </template>
            <template v-slot:cell(action)="data">
              <div class="flex align-items-center list-user-action">
                <span v-if="data.item.status == '0'">
                  <a
                    class="iq-bg-green-white"
                    data-toggle="tooltip"
                    data-placement="top"
                    :id="`tooltip-target-chot-${data.item.id}`"
                    title
                    data-original-title="Chốt báo cáo"
                    v-b-modal.modal-299
                    @click="openReport(data.item)"
                  >
                  <i class="las la-exchange-alt text-green"></i>
                </a>
                <b-tooltip :target="`tooltip-target-chot-${data.item.id}`" triggers="hover" placement="left">
                    Chốt
                </b-tooltip>
                </span>
                <span v-else>
                  <a class="iq-bg-blue-white" :id="`tooltip-target-unlock-${data.item.id}`" @click="unlockReport(data.item)" v-b-modal.modal-300>
                    <i class="las la-check-circle text-green"></i>
                  </a>
                  <b-tooltip :target="`tooltip-target-unlock-${data.item.id}`" triggers="hover" placement="left">
                    Mở khóa
                  </b-tooltip>
                </span>
                <a
                  class="iq-bg-red-white"
                  data-toggle="tooltip"
                  data-placement="top"
                  :id="`tooltip-target-remove-${data.item.id}`"
                  title
                  data-original-title="Xóa báo cáo"
                  @click="removeReport(data.item)"
                >
                  <i class="las la-times-circle text-red"></i>
                </a>
                <b-tooltip :target="`tooltip-target-remove-${data.item.id}`" triggers="hover" placement="right">
                    Xóa
                </b-tooltip>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
      <b-col sm="12" md="8">
        <b-card v-show="detailReport.detail_report !== null">
          <tab-nav :tabs="true" id="reportTab">
            <tab-nav-items :active="true" id="report-tab-1" ariaControls="report1" role="tab" :ariaSelected="true">
              <template v-slot:title>
                <b class="text-red">BÁO CÁO</b><br/>
                <small>VND: {{detailReport.report_total_vnd | numberFormat}}</small><br/>
                <small>USD: {{detailReport.report_total_usd | numberFormat}}</small>
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" id="report-tab-2" ariaControls="report2" role="tab" :ariaSelected="false">
              <template v-slot:title>
                <b class="text-red">BÁO CÁO THU CHI</b><br/>
                <small>VND: {{detailReport.summary_total_vnd | numberFormat}}</small><br/>
                <small>USD: {{detailReport.summary_total_usd | numberFormat}}</small>
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" id="report-tab-3" ariaControls="report3" role="tab" :ariaSelected="false">
              <template v-slot:title>
                <b class="text-red">BÁO CÁO THANH TOÁN</b><br/>
                 <small>VND: {{detailReport.payment_total_vnd | numberFormat}}</small><br/>
                 <small>USD: {{detailReport.payment_total_usd | numberFormat}}</small>
              </template>
            </tab-nav-items>
          </tab-nav>
          <tab-content id="reportTabContent">
  <!--      Báo cáo  -->
            <tab-content-item :active="true" id="report1" aria-labelled-by="report1" >
                <report-detail :detail="detailReport.detail_report" :id="'report-list-table'" />
            </tab-content-item>
  <!--      Báo cáo thu chi  -->
            <tab-content-item :active="false" id="report2" aria-labelled-by="report2" >
              <b-row>
                <b-col lg="6">
                </b-col>
                <b-col lg="6" class="text-right mb-3">
                  <b-button v-b-modal.modal-2 size="sm" :variant="'primary'"><i class="las la-exchange-alt las-small"></i>Nạp / Rút</b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12">
                  <span class="report-range-title" v-if="detailReport.detail_report">
                      {{ detailReport.detail_report.from_date | formatDateVN }} <i class="las la-arrow-right"></i> {{ detailReport.detail_report.to_date | formatDateVN }}
                  </span>
                  <b-button-group size="md" class="mb-3" style="float: right">
                    <b-button :variant="filter.categorySelect2 == 'all' ? 'primary' : 'secondary'" @click="filter.categorySelect2 = 'all';">Tất cả</b-button>
                    <b-button :variant="filter.categorySelect2 == 'ke_toan' ? 'primary' : 'secondary'" @click="filter.categorySelect2 = 'ke_toan';">Kế toán</b-button>
                    <b-button :variant="filter.categorySelect2 == 'no_cu' ? 'primary' : 'secondary'" @click="filter.categorySelect2 = 'no_cu';">Nợ cũ</b-button>
                    <b-button :variant="filter.categorySelect2 == 'khac' ? 'primary' : 'secondary'" @click="filter.categorySelect2 = 'khac';">Khác</b-button>
                  </b-button-group>
                  <report-all v-show="filter.categorySelect2 == 'all'" :detail="detailReport.summary_success_report" />
                  <ke-toan v-show="filter.categorySelect2 == 'ke_toan'"/>
                  <debtor v-show="filter.categorySelect2 == 'no_cu'"/>
                  <other v-show="filter.categorySelect2 == 'khac'"/>
                </b-col>
              </b-row>
            </tab-content-item>
  <!--      Báo cáo tuần -->
            <tab-content-item :active="false" id="report3" aria-labelled-by="report3" >
              <b-row>
                <b-col class="text-right mb-3">
                  <span class="report-range-title" v-if="detailReport.detail_report">
                      {{ detailReport.detail_report.from_date | formatDateVN }} <i class="las la-arrow-right"></i> {{ detailReport.detail_report.to_date | formatDateVN }}
                  </span>
                  <payment/>
                </b-col>
              </b-row>
            </tab-content-item>
          </tab-content>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-299" title="Chốt báo cáo" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
        <h4><i class="las la-exchange-alt"/> Chốt báo cáo</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b-form>
                <b-form-group label="Chọn chu kỳ">
                  <v-select plain v-model="payment_cycle" :reduce="opt => opt.id" :options="rangeReportOptions" placeholder="Chọn chu kì"/>
                </b-form-group>
              </b-form>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" :disabled="!payment_cycle" @click="lockReport">Xác nhận</b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import ReportDetail from './components/ReportDetail'
import ReportAll from './components/DepositWithdraw/ReportAll'
import KeToan from './components/DepositWithdraw/KeToan'
import Debtor from './components/DepositWithdraw/Debtor'
import Other from './components/DepositWithdraw/Other'
import Payment from './components/DepositWithdraw/Payment'

import api from '../../store/api'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReportList',
  components: { ReportDetail, ReportAll, KeToan, Debtor, Other, Payment },
  mounted () {
    findash.index()
    this.resetDetailReport()
  },
  created () {
    this.isBusy = true
    this.pageChange()
  },
  data () {
    return {
      filter: {
        categorySelect2: 'all'
      },
      reportFields: [
        {
          key: 'report_range',
          label: 'Từ ngày - đến ngày',
          class: 'text-center'
        },
        {
          key: 'action',
          label: '',
          thStyle: { width: '40%' },
          class: 'text-right'
        }
      ],
      reportList: [],
      reportChoice: null,
      isBusy: false,
      payment_cycle: null
    }
  },
  computed: {
    ...mapGetters({
      'rangeReportOptions': 'Report/rangeReportListOptionsState',
      'detailReport': 'Report/detailReportState',
      'serverError': 'Setting/serverErrorsState'
    })
  },
  methods: {
    ...mapActions({
      'loadDetailReport': 'Report/loadDetailReport',
      'loadListReport': 'Report/loadList',
      'resetDetailReport': 'Report/resetDetailReport',
      'serverErrorAction': 'Setting/serverErrorAction'
    }),
    async pageChange () {
      this.reportList = await this.loadListReport()
      this.isBusy = false
    },
    confirm () {

    },
    openReport (choice) {
      this.reportChoice = choice
      this.payment_cycle = choice.id
    },
    lockReport () {
      api.report.lockReportDetail({
        id: this.reportChoice.id,
        belong_id: this.payment_cycle
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Chốt thành công'
        })
        this.pageChange()
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    unlockReport (choice) {
      this.$swal({
        icon: 'question',
        title: 'Mở khóa báo cáo từ ngày',
        text: `Từ ngày ${choice.from_date} tới ${choice.to_date}`,
        showCancelButton: true,
        confirmButtonColor: '#1e3d73',
        cancelButtonColor: '#a09e9e',
        confirmButtonText: 'Chốt',
        cancelButtonText: 'Hủy'
      }).then((result) => {
        if (result.isConfirmed) {
          api.report.unlockReportDetail({
            report_id: choice.id
          }).then((res) => {
            this.$swal({
              icon: 'success',
              title: 'Mở khóa thành công'
            })
            this.pageChange()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        }
      })
    },
    removeReport (choice) {
      this.$swal({
        icon: 'warning',
        title: 'Xóa báo cáo',
        text: `Từ ngày ${choice.from_date} tới ${choice.to_date}`,
        showCancelButton: true,
        confirmButtonColor: '#dd4b39',
        cancelButtonColor: '#a09e9e',
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy'
      }).then((result) => {
        if (result.isConfirmed) {
          api.report.removeReportDetail(choice.id).then((res) => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            this.pageChange()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            }).then(() => {
              this.serverErrorAction('')
            })
          })
        }
      })
    }
  }
}
</script>
